import { initializeApp } from 'firebase';
import 'firebase/firestore';

const firebaseApp = initializeApp({
  apiKey: "AIzaSyAA4p_QVAj1WB8WHUx4L2NW8M3vG5Fq5dA",
  authDomain: "puestadorada-8a9f6.firebaseapp.com",
  databaseURL: "https://puestadorada-8a9f6.firebaseio.com",
  projectId: "puestadorada-8a9f6",
  storageBucket: "puestadorada-8a9f6.appspot.com",
  messagingSenderId: "412302108663",
  appId: "1:412302108663:web:d3c8518aae18ea0bfbf0f2"
});

// Export Modules
export const auth = firebaseApp.auth();
export const database = firebaseApp.firestore();
export const storage = firebaseApp.storage();

database.settings({ timestampsInSnapshots: true });
// database.enablePersistence()

// var room = {
//   link:'',
//   img: '',
//   citiesAvailable: [
//     'bbZUHWYapXeQP4niAzYE',
//     'UInF1o4ZA2xJfkxOCr75',
//     'B6IJ8ApAlK19L7aiqwDe',
//     's2UCkpsNk8Z0AaQISJWM',
//     'tcDrdyhzXakBARtqRuBN',
//     'DUQft0PHIhnuG0pQn1EK'
//   ],
//   resortId: 'iqr2jeY9lsggqQm1FLDj',
//   information: {
//     english: {
//       name: '',
//       description: '',
//       price: {
//         night: '',
//         week: 'UNDEFINED'
//       },
//       type: '',
//       bed: '',
//       bathroom: '',
//     },
//     spanish: {
//       name: '',
//       description: '',
//       price: {
//         night: '',
//         week: 'UNDEFINED'
//       },
//       type: '',
//       bed: '',
//       bathroom: '',
//     },
//     occupants: {
//       adults: '',
//       kids: '2'
//     },
//   },


// }
// database.collection('rooms/').add(room)
//   .then(async (ref) => {
//     database.collection('rooms/').doc(ref.id).set({
//       'id': ref.id,
//     }, { merge: true });
//   })





export const authCheking = async (cb) => {
  auth.onAuthStateChanged(async (user) => {
    cb(user);
  });
}
